import React, { Fragment } from 'react';
import { Text } from '@libs/uikit/Components';
import { Field, FieldPassback } from "./adSpotGrops/Field";
import { Title } from './options/Title';
import { toggleAdUnitCheckbox, updateAk, updateSelectedField, updatePassbackSize } from '../utils';

export const AdSpot = (props) => {
	const { onOver, adUnits, select } = props;

	const changePassbackSize =
        (dimension = 'width') =>
        (value) => {
            select(updatePassbackSize(adUnits, dimension, value));
        };
	const getPropsBy = name => ({
		...adUnits[name],
		name,
		changeAk: (name, ak) => select(updateAk(adUnits, name, ak)),
		onOver,
		toggleAutoClose: () => select(toggleAdUnitCheckbox(adUnits, name, 'autoClose')),
		toggleVcr: () => select(toggleAdUnitCheckbox(adUnits, name, 'vcr')),
		onChange: () => select(toggleAdUnitCheckbox(adUnits, name, 'selected')),
		checkSelectedField: () => select(updateSelectedField(adUnits, name))
	});
	return props.activeTab !== 'SAFE FRAME' ?
		// Not safeFrame
		<Fragment>
			<Title>Ad Spot configuration</Title>
			<Text caption>In-feed</Text>

			<Field {...getPropsBy('inFeedLandscape')}/>
			<Field {...getPropsBy('inFeedPortrait')}/>
			<Field {...getPropsBy('fullscreenPortraitScroller')}/>
			<Field {...getPropsBy('mpu')}/>
			<Field {...getPropsBy('phoneBanner')}/>
			<Field {...getPropsBy('leaderboard')}/>
            <Field {...getPropsBy('skyscraper')}/>
            <Field {...getPropsBy('halfpage')}/>

			{/* {props.activeTab === 'DFP' && <FieldPassback {...getPropsBy('passback')}/>} */}
			<FieldPassback {...getPropsBy('passback')} changePassbackSize={changePassbackSize}/>

			<Text caption>On top of content</Text>
			<Field {...getPropsBy('richMediaPortrait')}/>
			<Field {...getPropsBy('inView')}/>
			<Field {...getPropsBy('expandableBanner')}/>
		</Fragment> :
		// Safe Frame
		<Fragment>
			<Field {...getPropsBy('safeInFeedLandscape')}/>
			<Field {...getPropsBy('htmlRichMedia')}/>
		</Fragment>;
};
